import SuperScriptStr from 'components/atoms/String/SuperScriptStr';
import { OtrData } from 'interfaces/OtrData.interface';
import { FC, useEffect, useRef, useState } from 'react';

interface ITimer {
  otr: OtrData;
}

const OtrTimer: FC<ITimer> = ({ otr }) => {
  const timerRef = useRef<ReturnType<typeof setInterval>>();
  const [timeLeft, setTimeLeft] = useState<string>('');

  useEffect(() => {
    const otrCreateDate = new Date(otr.createdAt);
    otrCreateDate.setDate(otrCreateDate.getDate() + 3);

    timerRef.current = setInterval(() => {
      const now = new Date().getTime();

      const distance = otrCreateDate.getTime() - now;

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (distance > 0) {
        setTimeLeft(days + '//' + hours + '/-/' + minutes + '/-/-/' + seconds);
      }
      // else {
      //   setTimeLeft(0 + '//' + 0 + '/-/' + 0 + '/-/-/' + 0);
      // }
    }, 1000);

    return () => {
      clearInterval(timerRef.current);
    };
    // eslint-disable-next-line
  }, [otr.id]);

  return (
    <>
      <SuperScriptStr
        text={timeLeft && timeLeft.split('//')[0] + ':'}
        sup={false}
        style={{
          color: 'white',
          fontSize: '15px',
        }}
      />
      <SuperScriptStr
        text={timeLeft && timeLeft.split('//')[1]?.split('/-/')[0] + ':'}
        sup={false}
        style={{
          color: 'white',
          fontSize: '15px',
        }}
      />
      <SuperScriptStr
        text={timeLeft && timeLeft.split('//')[1]?.split('/-/')[1] + ':'}
        sup={false}
        style={{
          color: 'white',
          fontSize: '15px',
        }}
      />
      <SuperScriptStr
        text={timeLeft && timeLeft.split('/-/-/')[1]}
        sup={false}
        style={{
          color: 'white',
          fontSize: '15px',
        }}
      />
    </>
  );
};

export default OtrTimer;
